module.exports = __webpack_public_path__ + "img/red.0c52c617.png";